<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>审核</BreadcrumbItem>
          <BreadcrumbItem>直播审核</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">直播审核列表</div>
        <Input search placeholder="请输入活动关键字" v-model="search" @on-search="searchPro"
          style="width:230px;margin-top:20px;" />
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="exportInfo">
          <span>
            <i class="icon iconfont icon-shangchuan"></i>
          </span>
          <span>导出</span>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <div v-if="list.length">
        <Table :columns="columns" :data="list" style="min-height: 500px">
          <template slot-scope="{ row }" slot="companyName">{{ row.companyName }}</template>
          <template slot-scope="{ row }" slot="apply">{{ row.name }}</template>

          <template slot-scope="{ row }" slot="links">{{ row.liveLinkName }}</template>
          <template slot-scope="{ row }" slot="phone">{{ row.livelinkTel }}</template>
          <template slot-scope="{ row }" slot="state">
            <span v-if="row.liveAudit === 'not'">无须审核</span>
            <span v-if="row.liveAudit === 'wait'">待审核</span>
            <span v-if="row.liveAudit === 'pass'">审核通过</span>
            <span v-if="row.liveAudit === 'notpass'">驳回</span>
          </template>

          <template slot-scope="{ row }" slot="submitTime">
            <span v-if="row.liveStartTime">{{ row.liveStartTime | moment("YYYY/MM/DD HH:mm") }} - {{ row.liveEndTime
                |
                moment("YYYY/MM/DD HH:mm")
            }}</span>
          </template><template slot-scope="{ row }" slot="liveApplyTime">
            <span v-if="row.liveApplyTime">{{ row.liveApplyTime | moment("YYYY/MM/DD HH:mm:ss") }} </span>
          </template>

          <template slot-scope="{ row }" slot="edit">
            <a href="javascript:;" @click="changeLive(row)">修改</a>
            <span class="u-split">|</span>
            <a href="javascript:;" @click="linkToLive(row)" v-if="row.liveAudit === 'pass' && row.liveChannelId">查看</a>
            <a href="javascript:;" style="color:#ccc;" v-else>查看</a>
            <span class="u-split">|</span>
            <a href="javascript:;" @click="editInfo = row; show = true;" v-if="row.liveAudit === 'wait'">通过</a>
            <a href="javascript:;" style="color:#ccc" v-else>通过</a>
            <span class="u-split">|</span>
            <template v-if="row.liveAudit === 'wait'">
              <!-- <Poptip confirm title="确认是否驳回?" @on-ok="noPassHandle(row)" placement="top-end" transfer> -->
                <a href="javascript:;" style="color:red;"  @click="rejectP(row)">驳回</a>
              <!-- </Poptip> -->
            </template>
            <a href="javascript:;" style="color:#ccc;" v-else>驳回</a>
          </template>
        </Table>
        <div class="my-page" v-if="totalCount > size" style="margin: 20px;text-align: center;padding-bottom: 20px;">
          <Page show-total show-elevator :page-size="size" :current="page" :total="totalCount" @on-change="changePage"
            @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <commonAdAdd :show="show" @finish="init()" @close="show = false;" :info="editInfo" />

    <editHostLive :show="hostOpen" @finish="init()" @close="hostOpen = false; hostOpenInfo = null;"
      :info="hostOpenInfo" />

      <iModal :title="modelTitle" v-model="rejectModel" class-name="vertical-center-modal" width="600px"
            :mask-closable="false">

            <Input v-model="rejectValue" type="textarea" :rows="4" placeholder="请输入..."></Input>

            <div slot="footer">
                <Button type="primary" @click="noPassHandle()">确定</Button>
                <Button @click="rejectModel = false">取消</Button>
            </div>
        </iModal>

  </div>
</template>

<script>
import commonAdAdd from "./components/common-ad-add.vue";
import editHostLive from "./components/edit-host-live.vue";
import config from '@assets/config.json'; // api 请求json 
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-audit-list",
  components: {
    commonAdAdd,
    editHostLive,
  },
  data () {
    return {
        rejectModel: false,
        rejectValue:"",
        modelTitle:"",
        rowUser:{},






      hostOpen: false,
      hostOpenInfo: null,
      show: false,
      search: "",
      editInfo: null,
      page: 1,
      size: 10,
      totalCount: 0,
      columns: [
        {
          title: "展商",
          slot: "companyName",
          width: 220
        },
        {
          title: "申请直播活动",
          slot: "apply",
          width: 200
        },
        {
          title: "直播时间",
          slot: "submitTime",
        },
        {
          title: "联系人",
          slot: "links",
        },
        {
          title: "手机号",
          slot: "phone",
        },
        {
          title: "状态",
          slot: "state",
        },
        {
          title: "提交时间",
          slot: "liveApplyTime",
        },
        {
          title: "操作",
          slot: "edit",
          align: "center"
        }
      ],
      list: [],
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition"
    }),
    option () {
      return {
        size: this.size,
        page: this.page,
        searchText: this.search,
        isApplyLive: true,
        activityType: 'exhibitor',
      };
    }
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getActivityLiveQuery: "liveModule/getActivityLiveQuery",
      applyAudit: "liveModule/applyAudit",
    }),
    async init () {
      let proData = await this.getActivityLiveQuery(this.option);
      if (proData) {
        this.list = proData.items;
        this.size = proData.size;
        this.page = proData.page;
        this.totalCount = proData.totalCount;
      }
    },
    changePage (e) {
      this.page = e;
      this.init();
    },
    changePageSize (e) {
      this.size = e;
      this.init();
    },
    edit (item) {
      this.editInfo = item;
    },
    searchPro () {
      this.page = 1;
      this.init();
    },

    rejectP (row, index) {
            this.rejectValue = ''
            this.rowUser = row
            this.modelTitle = '请填写驳回原因：'
            this.rejectModel = true
        },

    // 直播驳回
    async noPassHandle (item) {
        if (!this.rejectValue) {
                this.$Message.warning('驳回理由不能为空！')
                return
            }
      let opt = {
        activityId: this.rowUser.id,
        audit: 'notpass',
        auditRemark: this.rejectValue,
        liveWheatNumber: 0,
        isOpenBlackLive: false,
      }
      let info = await this.applyAudit(opt);
      if (info) {
        this.$Message.success("操作成功");
        this.rejectModel = false
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    linkToLive (item) {
      if (item.liveAudit !== 'pass') return;
      this.$router.push(`/host/index/act/act-live?type=live&channelId=${item.liveChannelId}&activityId=${item.id}`);
    },
    changeLive (item) {
      this.hostOpen = true;
      this.hostOpenInfo = item;
      console.log('hostOpenInfo', item);
    },
    exportInfo () {

      const link = `${config.api.reqApi}/live/api/live/by-exhibitin-export/${this.exhibitionInfo.id}.xlsx`;
      window.open(link);
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;

  button {
    margin-right: 20px;
  }
}
</style>

